/* Fuego & Fragancia — memoria de lo que cada persona ha mirado.

   Dos piezas que trabajan juntas:

     1. El registro. En cada página de producto y en cada búsqueda se guarda en
        localStorage qué se vio y qué se buscó. Nada de esto sale del navegador
        y no hace ninguna petición.

     2. <ff-picks>. Reordena una parrilla de productos que el servidor ya pintó
        entera, poniendo delante lo que le interesa a esta persona concreta.

   POR QUÉ REORDENAR EN VEZ DE PEDIR
   El servidor pinta todo el fondo de armario (hasta `pool_size` productos) y
   esconde lo que sobra. El JS solo decide el orden y qué se ve. Así:
     · sin JS, la parrilla sigue mostrando los primeros productos y nadie ve
       una caja vacía;
     · no hay ni una petición extra en una página 404, que es justo donde la
       paciencia está bajo mínimos;
     · los precios y los títulos salen del servidor, ya traducidos y en la
       moneda del mercado, sin tener que reconstruirlos a mano.

   El orden que pinta el servidor es el respaldo, y es el que manda cuando no
   hay historial: primera visita, modo incógnito o localStorage bloqueado. */

(function () {
  var CLAVE_VISTOS = 'ff:viewed';
  var CLAVE_BUSCADO = 'ff:searched';
  var MAX_VISTOS = 24;
  var MAX_BUSCADO = 8;

  // localStorage lanza excepción en incógnito de Safari y con las cookies
  // bloqueadas. Nada de esto es imprescindible, así que si falla se sigue.
  function leer(clave) {
    try {
      var bruto = window.localStorage.getItem(clave);
      var datos = bruto ? JSON.parse(bruto) : [];
      return Array.isArray(datos) ? datos : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(clave, datos) {
    try {
      window.localStorage.setItem(clave, JSON.stringify(datos));
    } catch (e) {
      /* sin memoria, pero la página funciona igual */
    }
  }

  function json(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------------------------------------------------- 1. El registro --- */

  var visto = json('FfViewedProduct');
  if (visto && visto.handle) {
    var lista = leer(CLAVE_VISTOS).filter(function (x) {
      return x && x.h !== visto.handle;
    });
    lista.unshift({
      h: visto.handle,
      t: visto.type || '',
      c: visto.collections || [],
      d: Date.now(),
    });
    guardar(CLAVE_VISTOS, lista.slice(0, MAX_VISTOS));
  }

  var buscado = json('FfSearchedTerm');
  if (buscado && buscado.term) {
    var termino = String(buscado.term).trim().toLowerCase();
    if (termino) {
      var terminos = leer(CLAVE_BUSCADO).filter(function (x) {
        return x !== termino;
      });
      terminos.unshift(termino);
      guardar(CLAVE_BUSCADO, terminos.slice(0, MAX_BUSCADO));
    }
  }

  /* ------------------------------------------------------ 2. <ff-picks> --- */

  if (customElements.get('ff-picks')) return;

  customElements.define(
    'ff-picks',
    class FfPicks extends HTMLElement {
      connectedCallback() {
        this.pool = this.querySelector('[data-pool]');
        if (!this.pool) return;

        var cartas = Array.prototype.slice.call(this.pool.children);
        if (!cartas.length) return;

        var vistos = leer(CLAVE_VISTOS);
        var terminos = leer(CLAVE_BUSCADO);
        if (!vistos.length && !terminos.length) return; // el orden del servidor ya vale

        var cuantos = parseInt(this.dataset.show || '4', 10);

        var tiposVistos = {};
        var coleccionesVistas = {};
        vistos.forEach(function (v) {
          if (v.t) tiposVistos[v.t.toLowerCase()] = true;
          (v.c || []).forEach(function (c) {
            coleccionesVistas[c] = true;
          });
        });

        var posicionVista = {};
        vistos.forEach(function (v, i) {
          posicionVista[v.h] = i;
        });

        var self = this;
        var puntuadas = cartas.map(function (carta, orden) {
          return { carta: carta, orden: orden, punto: self.puntuar(carta, posicionVista, tiposVistos, coleccionesVistas, terminos) };
        });

        // A igualdad de puntos manda el orden del servidor: así la mezcla es
        // estable y no baila en cada recarga.
        puntuadas.sort(function (a, b) {
          if (b.punto !== a.punto) return b.punto - a.punto;
          return a.orden - b.orden;
        });

        var fragmento = document.createDocumentFragment();
        puntuadas.forEach(function (p, i) {
          if (i < cuantos) p.carta.removeAttribute('data-hidden');
          else p.carta.setAttribute('data-hidden', '');
          fragmento.appendChild(p.carta);
        });
        this.pool.appendChild(fragmento);

        // El encabezado cambia solo si de verdad hay algo reconocible arriba.
        var reconocido = puntuadas.slice(0, cuantos).some(function (p) {
          return posicionVista[p.carta.dataset.handle] !== undefined;
        });
        var titulo = this.querySelector('[data-heading]');
        if (reconocido && titulo && this.dataset.headingSeen) {
          titulo.textContent = this.dataset.headingSeen;
        }
      }

      /* Escalera de afinidad, de lo más personal a lo más genérico:
           1000  ya lo miró           — lo que estaba buscando, casi seguro
            600  coincide con lo que escribió en el buscador
            400  mismo tipo de producto que algo que miró
            250  comparte colección con algo que miró
              0  relleno, en el orden que decidió el servidor
         Dentro de cada peldaño se conserva el orden del servidor. */
      puntuar(carta, posicionVista, tipos, colecciones, terminos) {
        var handle = carta.dataset.handle || '';
        var tipo = (carta.dataset.type || '').toLowerCase();
        var titulo = (carta.dataset.title || '').toLowerCase();
        var suyas = (carta.dataset.collections || '').split(',').filter(Boolean);

        if (posicionVista[handle] !== undefined) {
          // Cuanto más reciente, más arriba.
          return 1000 - posicionVista[handle];
        }

        var coincideBusqueda = terminos.some(function (t) {
          return t.length > 2 && (titulo.indexOf(t) >= 0 || tipo.indexOf(t) >= 0);
        });
        if (coincideBusqueda) return 600;

        if (tipo && tipos[tipo]) return 400;

        var comparte = suyas.some(function (c) {
          return colecciones[c];
        });
        if (comparte) return 250;

        return 0;
      }
    }
  );
})();
